<template>
	<div>
		<div class="flex flex-wrap gap-x-6 gap-y-3" v-if="hasQualityTypeRadio">
			<ui-radio-group
				v-model="qualityType"
				radioValue="STANDARD"
				:key="'true-' + qualityType"
				name="qualityType"
				label="Standard Quality"
				tooltip-text="Goods with predefined, standard quality parameters."
			>
			</ui-radio-group>

			<ui-radio-group
				v-model="qualityType"
				name="qualityType"
				radioValue="SPECIFIC"
				:key="'false-' + qualityType"
				label="Specific Quality"
				tooltip-text="Goods with individual or tested quality."
			>
			</ui-radio-group>
		</div>

		<div
			v-if="showQualityStandardSelector"
			class="md:grid md:grid-cols-2 gap-x-6"
		>
			<ui-select-group
				v-model="form.product.quality_standard_id"
				field="product.quality_standard_id"
				type="select"
				label="Quality Standard"
				:options="qualityStandardOptions"
				:form="form"
				:required="true"
				:no-label="true"
				v-on:change="qualityStandardChanged()"
				class="mt-6"
			></ui-select-group>
		</div>

		<!-- :class="'grid-cols-'+gridCols" -->
		<offer-edit-specific-quality
			v-if="qualityType == 'SPECIFIC'"
			v-model="form"
			:suppress-gmp="farmerInvolved"
			:key="'SPECFIIC_QUALITY-' + form.product.quality_standard_id"
			class="mt-6 grid gap-y-4 gap-x-6 items-center"
		></offer-edit-specific-quality>

		<!-- semi / to do discuss -->
		<crop-quality-summary
			v-else
			class="mt-2"
			:tradable="form"
			ul-class="flex flex-wrap"
			li-class="mr-4"
		/>
	</div>
</template>

<script>
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
		gridCols: {
			type: String,
			default: "2",
		},
		user: {
			type: Object,
			default: null,
		},
		counterpart: {
			type: Object,
			default: null,
		},
		creating: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		qualityStandardOptions() {
			// quality standards available for the current product grade
			let grade = this.form.product.grade;
			return this.$cropOptions.qualityStandardOptions[grade];
		},
		qualityType: {
			get() {
				return this.form.product.quality_standard_id == null
					? "SPECIFIC"
					: "STANDARD";
			},
			set(newValue) {
				if (newValue == "STANDARD") {
					this.form.product.quality_standard_id =
						this.qualityStandardOptions[0].id;
					this.qualityStandardChanged();
				} else {
					console.log("HAS STANDARD QUALTIY = FALSE");
					this.form.product.quality_standard_id = null;
					this.clearFarmerGmp();
				}
			},
		},
		farmerInvolved() {
			// Landwirt als Käufer oder Verkäufer → GMP+/FSA nicht wählbar. Gegenpart nur beim Gebot gesetzt.
			return (
				(this.user != null && this.user.type === "FARMER") ||
				(this.counterpart != null && this.counterpart.type === "FARMER")
			);
		},
		showQualityStandardSelector() {
			return (
				this.qualityType === "STANDARD" &&
				(this.qualityStandardOptions || []).length > 1
			);
		},
		hasQualityTypeRadio() {
			if (this.form.product.grade == "WHEAT_B__OTHER") {
				return false;
			}
			return true;
		},
	},
	methods: {
		qualityStandardChanged() {
			let that = this,
				qualityStandard = this.qualityStandardOptions.filter(
					(o) => o.id == that.form.product.quality_standard_id
				)[0];
			if (!qualityStandard) {
				console.log("quality standard not found");
				return;
			}
			Object.keys(this.form.quality).forEach(function (key) {
				if (qualityStandard[key]) {
					that.form.quality[key] = qualityStandard[key];
				} else {
					that.form.quality[key] = null;
				}
			});
			this.clearFarmerGmp();
			console.log("quality standard applied", qualityStandard);
		},
		clearFarmerGmp() {
			// Bei Landwirt-Beteiligung einen aus Inserat/Standard übernommenen gmp-Wert entfernen.
			if (this.farmerInvolved && this.form.quality.gmp_certified != null) {
				this.form.quality.gmp_certified = null;
			}
		},
	},
	created() {
		this.clearFarmerGmp();
	},
	watch: {
		qualityType(qualityType) {
			console.log(
				"WATCHER QT",
				qualityType,
				this.form.product.grade,
				this.form.product.grade.startsWith("WHEAT_B__")
			);
			if (
				qualityType == "SPECIFIC" &&
				this.form.product.grade.startsWith("WHEAT_B__")
			) {
				this.form.product.grade = "WHEAT_B__OTHER";
				console.log("UPDATING PRODUCT GRADE");
			}
		},
	},
};
</script>
